import React, { useState, useEffect } from 'react';
import { Menu, X, Sparkles } from 'lucide-react';
import { Button } from './ui/button';

const navItems = [
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Gallery', href: '#gallery' },
  { label: 'Testimonials', href: '#testimonials' },
  { label: 'Contact', href: '#contact' },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      {/* Special offer bar */}
      <div className="w-full bg-gradient-to-r from-rose-500 via-pink-500 to-pink-600 text-white text-center py-2.5 px-4 text-sm font-medium relative z-50">
        <span className="inline-flex items-center gap-2">
          <Sparkles className="h-4 w-4" />
          Special Offer: Get 10% OFF all services when you book online!
          <Sparkles className="h-4 w-4" />
        </span>
      </div>

      <header
        className={`sticky top-0 z-40 w-full transition-all duration-300 ${
          scrolled
            ? 'bg-white/90 backdrop-blur-md shadow-sm border-b border-pink-100'
            : 'bg-white border-b border-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <button
              onClick={() => scrollTo('#home')}
              className="flex items-center gap-2 group"
              aria-label="S Pink Nails Home"
            >
              <div className="relative">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-pink-100 to-rose-100 border border-pink-200 flex items-center justify-center shadow-sm">
                  <span className="font-display text-pink-600 font-bold text-xl italic">S</span>
                </div>
              </div>
              <div className="flex flex-col leading-tight text-left">
                <span className="font-display font-semibold text-lg text-pink-600 italic">Pink</span>
                <span className="font-display font-semibold text-sm text-pink-500 -mt-1 italic">Nails</span>
              </div>
            </button>

            {/* Desktop Nav */}
            <nav className="hidden md:flex items-center gap-8">
              {navItems.map((item) => (
                <button
                  key={item.href}
                  onClick={() => scrollTo(item.href)}
                  className="nav-link font-body text-sm font-medium text-gray-700"
                >
                  {item.label}
                </button>
              ))}
              <Button
                onClick={() => scrollTo('#booking')}
                className="bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 text-white font-medium shadow-md hover:shadow-lg transition-all rounded-full px-6"
              >
                Book Now
              </Button>
            </nav>

            {/* Mobile toggle */}
            <button
              className="md:hidden p-2 rounded-lg hover:bg-pink-50 transition"
              onClick={() => setOpen(!open)}
              aria-label="Toggle menu"
            >
              {open ? <X className="h-6 w-6 text-pink-600" /> : <Menu className="h-6 w-6 text-pink-600" />}
            </button>
          </div>

          {/* Mobile Nav */}
          {open && (
            <div className="md:hidden pb-4 border-t border-pink-100 pt-3 flex flex-col gap-3">
              {navItems.map((item) => (
                <button
                  key={item.href}
                  onClick={() => scrollTo(item.href)}
                  className="text-left py-2 px-2 font-medium text-gray-700 hover:text-pink-600 hover:bg-pink-50 rounded-md transition"
                >
                  {item.label}
                </button>
              ))}
              <Button
                onClick={() => scrollTo('#booking')}
                className="bg-gradient-to-r from-pink-500 to-rose-500 text-white rounded-full mt-2"
              >
                Book Now
              </Button>
            </div>
          )}
        </div>
      </header>
    </>
  );
};

export default Navbar;
